exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".presentation-prices-table .presentation-price-option{min-width:76px;padding:5px 9px;color:#606266;background:#fff;border:1px solid #dcdfe6;border-radius:4px;cursor:pointer;-webkit-transition:all .15s ease;transition:all .15s ease}.presentation-prices-table .presentation-price-option:hover{color:#00a991;border-color:#00bfa5;background:#f0fffc}.presentation-prices-table .presentation-price-option.selected{color:#fff;font-weight:600;background:#00b19d;border-color:#00b19d}.presentation-prices-table .presentation-price-option:disabled{color:#c0c4cc;background:#f5f7fa;border-color:#ebeef5;cursor:not-allowed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55b7b95a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/views/tenant/documents/partials/item.vue
// module id = +UUL
// module chunks = 0